<template>
  <a
    :href="href"
    :data-wa-source="source"
    target="_blank"
    rel="noopener"
    :aria-label="ariaLabel"
    @click="onClick"
  ><slot>Message us on WhatsApp</slot></a>
</template>

<script>
import { whatsappHref, trackWhatsappClick } from "@/utils/whatsapp";
import { pageContext } from "@/utils/pageContext";

// A plain wa.me link with data-wa-source, which GTM's "WhatsApp – Ref code
// + click ID" tag reads to append the Ref. Pushes whatsapp_click on tap.
export default {
  name: "WaLink",
  props: {
    source: { type: String, required: true },
    // Message variables: { suburb, ref, name, when, branch }. The page's
    // suburb is used when none is given.
    vars: { type: Object, default: () => ({}) },
    ariaLabel: { type: String, default: null },
  },
  computed: {
    href() {
      return whatsappHref(this.source, { suburb: pageContext.suburb, ...this.vars });
    },
  },
  methods: {
    onClick() {
      trackWhatsappClick(this.source);
    },
  },
};
</script>
